module.exports = __webpack_public_path__ + "img/5.a8177734.jpg";